import { configureStore } from "@reduxjs/toolkit";
import { 
    configSlice,
    userSlice,
    userAdminSlice,
    reviewsSlice,
    contactQuestionsSlice
} from "./slices";


// Cargar estado desde localStorage
const loadState = () => {
    try {
        const serializedState = localStorage.getItem("reduxState");
        if (serializedState === null) {
            return undefined;
        }
        // Parsear el estado guardado, pero solo usamos userLogged
        const parsedState = JSON.parse(serializedState);

        if (parsedState.userLogged?.expiration && 
                checkSessionExpiration(parsedState.userLogged.expiration)) {
            localStorage.removeItem("reduxState");
            return undefined;
        }

        return {
            configuration: configSlice.getInitialState(), // Use getInitialState() instead
            userLogged: parsedState.userLogged || userSlice.getInitialState(),
            userAdmin: parsedState.userAdmin || userAdminSlice.getInitialState(),
            reviews: parsedState.reviews || reviewsSlice.getInitialState(),
            contactQuestions: parsedState.contactQuestions || contactQuestionsSlice.getInitialState(),
            // configuration: configSlice.reducer(undefined, { type: '@@INIT' }), // Estado inicial de configuration
            // userLogged: parsedState.userLogged || undefined
        };
    } catch (err) {
        console.error("Error al cargar el estado:", err);
        return undefined;
    }
};


export const store = configureStore({
    reducer: {
        configuration: configSlice.reducer,
        userLogged: userSlice.reducer,
        userAdmin: userAdminSlice.reducer,
        reviews: reviewsSlice.reducer,
        contactQuestions: contactQuestionsSlice.reducer,
    },
    preloadedState: loadState(), // Estado inicial desde localStorage
});


// Suscribirse a cambios para guardar en localStorage
store.subscribe(() => {
    const state = store.getState();
    try {
        // Solo guardamos userLogged en localStorage
        const stateToPersist = {
            userLogged: state.userLogged,
            userAdmin: state.items,
            reviews: state.itemsReviews,
            contactQuestions: state.contactQuestions
        };
        localStorage.setItem("reduxState", JSON.stringify(stateToPersist));
    } catch (err) {
        console.error("Error al guardar el estado:", err);
    }
});